import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import './App.css'; // Import CSS for styling

const Footer: FC = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="app-footer">
      <div className="footer-content">
        <p>{t('footer_org_status')}</p>
        <p>{t('footer_copyright', { year: currentYear })}</p>
      </div>
    </footer>
  );
}

export default Footer; 
